<!-- 新建/编辑标签管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="标签类别" prop="name">
              <div class="list-img-box">
                <el-select v-model="formValidate.type" placeholder="请选择设施分类" :style="{width:'100%'}">
                  <el-option v-for="item in labelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="标签名称" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入地标名称" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="标签背景颜色" prop="backgroundColor">
              <div class="list-img-box">
                <el-color-picker v-model="formValidate.backgroundColor"></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="标签字体颜色" prop="wordColor">
              <div class="list-img-box">
                <el-color-picker v-model="formValidate.wordColor"></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="formValidate.remarks" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'LabelManagementOperation',
    data () {
      return {
        formValidate: {
          type: '',//添加标签类别
          name: '',//添加标签名称
          backgroundColor: '',//添加标签背景颜色
          wordColor: '',//添加标签字体颜色
          remarks: '',//备注
        },
        ruleValidate: { //学校非空验证
          name: [
            { required: true, message: '请输入地标名称', trigger: 'blur'}
          ],
          backgroundColor: [
            { required: true, message: '请选择标签背景颜色', trigger: 'change' },
          ],
          wordColor: [
            { required: true, message: '请选择标签字体颜色', trigger: 'change' },
          ],
        },
        labelList:[{label:'卖点标签',value:1},{label:'区域标签',value:2},{label:'地标标签',value:3},{label:'政策标签',value:4},{label:'金额标签',value:5},{label:'其他标签',value:6}],//添加设施分类1.卖点标签, 2.区域标签，3.地标标签，4.政策标签，5.金额标签，6.其他标签
      }
    },
    methods: {
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  category:this.formValidate.type,
                  name:this.formValidate.name,
                  color:this.formValidate.backgroundColor+'|'+this.formValidate.wordColor,
                  remark:this.formValidate.remarks,
                  status:1
                }
                this.$route.query.tableData.push(params);
              } else {
                params = {
                  id:this.$route.query.data.id,
                  category:this.formValidate.type,
                  name:this.formValidate.name,
                  color:this.formValidate.backgroundColor+'|'+this.formValidate.wordColor,
                  remark:this.formValidate.remarks,
                  status:1
                }
                for (let i = 0; i < this.$route.query.tableData.length; i++){
                  if(this.$route.query.tableData[i].id == this.$route.query.data.id){
                    this.$route.query.tableData[i] = params;
                  }
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateTagAssistantBatch({parameter: JSON.stringify(this.$route.query.tableData)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/LabelManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/LabelManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.id = this.$route.query.data.id;
        this.formValidate.name = this.$route.query.data.name;
        this.formValidate.type = this.$route.query.data.category;
        this.formValidate.backgroundColor = this.$route.query.data.color.split("|")[0];
        this.formValidate.wordColor = this.$route.query.data.color.split("|")[1];
        this.formValidate.remarks = this.$route.query.data.remark;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/LabelManagementOperation.vue